/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useState, useCallback } from "react";
import api from "../services/api";
import SweetAlert from "sweetalert2";
import { encrypt } from "../util/rotinas";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);

  const [firstAccess, setFirstAccess] = useState(false);

  const [logged, setLogged] = useState(() => {
    const isLogged = localStorage.getItem("@ipm:logged");

    return !!isLogged;
  });

  const checkCertificateValidity = async (token, user) => {
    api
      .get("/matera/check-certificate")
      .then((res) => {
        const data = res.data.data;
        const now = new Date();
        const expiration = new Date(data.validTo);
        if (
          now.toISOString() >= data.expiryWarningDate &&
          now.toISOString() <= data.validTo
        ) {
          SweetAlert.fire({
            title: "Aviso De Expiração",
            icon: "warning",
            footer: `O certificado da Matera expira em ${expiration.toLocaleDateString()}`,
            confirmButtonText: "OK",
          }).then((res) => {
            localStorage.setItem("@ipm:token", encrypt(token, false));
            localStorage.setItem("@ipm:user", encrypt(user, true));
            localStorage.setItem("@ipm:logged", "true");
            setAuthenticated(true);
            setLogged(true);
            setFirstAccess(true);
          });
        }
        localStorage.setItem("@ipm:token", encrypt(token, false));
        localStorage.setItem("@ipm:user", encrypt(user, true));
        localStorage.setItem("@ipm:logged", "true");
        setAuthenticated(true);
        setLogged(true);
        setFirstAccess(true);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleLogin = async (username, password) => {
    try {
      const response = await api.post("/session/auth", {
        username,
        password,
      });

      const token = response.data.data.token;
      const user = response.data.data.user;
      const certs = response.data.data.certs;

      api.defaults.headers.Authorization = `Bearer ${token}`;
      const now = new Date();
      const expiration = new Date(certs.validTo);

      if (
        now.toISOString() >= certs.expiryWarningDate &&
        now.toISOString() <= certs.validTo
      ) {
        SweetAlert.fire({
          title: "Aviso De Expiração",
          icon: "warning",
          footer: `O certificado da Matera expira em ${expiration.toLocaleDateString()}`,
          confirmButtonText: "OK",
        }).then((res) => {
          api.defaults.headers.Authorization = `Bearer ${token}`;
          localStorage.setItem("@ipm:token", encrypt(token, false));
          localStorage.setItem("@ipm:user", encrypt(user, true));
          localStorage.setItem("@ipm:logged", "true");
          setAuthenticated(true);
          setLogged(true);
          setFirstAccess(true);
        });
      } else {
        api.defaults.headers.Authorization = `Bearer ${token}`;
        localStorage.setItem("@ipm:token", encrypt(token, false));
        localStorage.setItem("@ipm:user", encrypt(user, true));
        localStorage.setItem("@ipm:logged", "true");
        setAuthenticated(true);
        setLogged(true);
        setFirstAccess(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleLogout = useCallback(() => {
    localStorage.removeItem("@ipm:token");
    localStorage.removeItem("@ipm:user");
    localStorage.removeItem("@ipm:logged");
    setAuthenticated(false);
    setLogged(false);
    window.location.href = "/";
  }, []);

  const handleFirstAccess = useCallback((value) => {
    setFirstAccess(value);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        authenticated,
        handleLogin,
        handleLogout,
        logged,
        firstAccess,
        handleFirstAccess,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

function useAuthentication() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuthentication must be used within an AuthProvider");
  }

  return context;
}

export { AuthProvider, useAuthentication, AuthContext };
